export default __webpack_public_path__ + "static/media/backgroundImg.1a84ff1a.png";